module.exports = __webpack_public_path__ + "static/media/Roboto-BoldItalic.5b44818d.ttf";